export const mediaBlockProps = {
	data: {
		type: Object,
		required: true,
	},
	editable: {
		type: Boolean,
		default: false,
	},
	active: {
		type: Boolean,
		default: false,
	},
	h5: {
		type: Boolean,
		default: false,
	},
	idKey: {
		type: String,
		default: '',
	},
};

export const mediaBlockEmits = ['select'];
